const randomElement = (arr = []) => {
  return arr[Math.floor(Math.random() * arr.length)];
};

const kebab = str => {
  return (str || '').replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
};

const toggleFullScreen = () => {
  let doc = window.document;
  let docEl = doc.documentElement;

  let requestFullScreen =
    docEl.requestFullscreen ||
    docEl.mozRequestFullScreen ||
    docEl.webkitRequestFullScreen ||
    docEl.msRequestFullscreen;
  let cancelFullScreen =
    doc.exitFullscreen ||
    doc.mozCancelFullScreen ||
    doc.webkitExitFullscreen ||
    doc.msExitFullscreen;

  if (
    !doc.fullscreenElement &&
    !doc.mozFullScreenElement &&
    !doc.webkitFullscreenElement &&
    !doc.msFullscreenElement
  ) {
    requestFullScreen.call(docEl);
  } else {
    cancelFullScreen.call(doc);
  }
};

export default {
  randomElement,
  toggleFullScreen,
  kebab
};

export const urlCRMBitrix = (ticketId) => {
  return `https://crm.vietmap.vn/services/lists/18/element/0/${ticketId}/?list_section_id=`;
};

export let pagination = {
  keySearch: '',
  pageIndex: 1,
  pageSize: 10000
};

export const FirebaseConfig = {
  apiKey: 'AIzaSyCC1eq0PSXFuJXAqhCfbqmeVW4XbsXZH10',
  authDomain: 'tracking-callcenter.firebaseapp.com',
  databaseURL: 'https://tracking-callcenter.firebaseio.com',
  projectId: 'tracking-callcenter',
  storageBucket: 'tracking-callcenter.appspot.com',
  messagingSenderId: '808508337367',
  appId: '1:808508337367:web:0a47241b80f1d7a7aa5492',
  measurementId: 'G-KKZK0VPKK1'
};

export const CallStatus = {
  EndCall: 'EndCall',
  Connected: 'Connected',
  Ringing: 'Ringing'
};

export let ApiUrl = {
  AppId: 'support',
  Login: process.env.LOGIN_URL
};

export const AppClientIDs = {
  Tracking: 'tracking.client',
  Navi: 'navi.client',
  Motrak: 'motrak.client',
  SC: 'sc.tracking.client'
};

export const WorkingStatus = {
  Ready: 'Ready',
  Plan: 'Plan',
  Offline: 'Offline'
};


// WEBPACK FOOTER //
// ./src/utils/index.js